// js/lib/config.js
// Central app configuration.
// Change BRAND_NAME here to update the white-label name across the entire UI.

export const BRAND_NAME = "Rewardlix";
